import React from 'react';
import { MessageView } from '@/components/ui/MessageView';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { ReloadIcon, StartUp02Icon } from '@hugeicons-pro/core-solid-rounded';
import { Alert02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/components/providers/AuthProvider';
import { usePaywallError } from '@/hooks/usePaywallError';

interface ErrorInListViewProps {
  error: any;
  onRetry: () => void;
  isRetrying: boolean;
}

export function ErrorInListView({ error, onRetry, isRetrying }: ErrorInListViewProps) {
  const { t } = useTranslation();
  const { signOutSoft } = useAuth();
  const { checkForPaywallError, navigateToPlans } = usePaywallError();

  const isUnauthorized = error?.status === 401;
  const paywallCheck = checkForPaywallError(error);
  const isForbidden = error?.status === 403 && !paywallCheck.isPaywall;

  const displayMessage = paywallCheck.isPaywall
    ? paywallCheck.message!
    : isForbidden 
      ? t('common.error.ipBlocked')
      : error.message;
  const displaySubText = paywallCheck.isPaywall ? paywallCheck.resetTimeMessage : undefined;

  return (
    <MessageView type="error" text={displayMessage} subText={displaySubText} icon={Alert02Icon}>
      {isUnauthorized ? (
        <ButtonWrapper
          action="primary"
          onPress={() => signOutSoft()}
          text={t('userMenu.signOut')}
          className="mt-4"
          isDisabled={isRetrying}
        />
      ) : paywallCheck.isPaywall ? (
        <ButtonWrapper
          icon={StartUp02Icon}
          action="primary"
          onPress={navigateToPlans}
          text={t('upgrade.upgrade_button')}
          className="mt-4"
        />
      ) : (
        <ButtonWrapper
          icon={ReloadIcon}
          action="primary"
          onPress={onRetry}
          text={t('common.retry')}
          className="mt-4"
          isDisabled={isRetrying}
        />
      )}
    </MessageView>
  );
} 